<template>
    <section>
        <PageTitle title="Point Of Sale" :class="{ 'hide': isBranchUser }" v-bind:crumbs="[{href:'/point_of_sale',title:'Point Of Sale'}]" />
        <div class="wrapper wrapper-content" style="padding-top: 0;">
            <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                <div class="sk-bounce1"></div>
                <div class="sk-bounce2"></div>
                <div class="sk-bounce3"></div>
            </div>
            <ResturantBranches ref="ResturantBranches" :class="{ 'hide': isBranchUser }" v-bind:selectedBranch="selectedBranch"></ResturantBranches>
            
            <BranchTables v-if="selectedTable.status === 0 || selectedTable.status === ''" ref="BranchTablesRef"
              :order-type-opened-from-menu="orderTypeOpened"
              :selected-branch="selectedBranch"
            ></BranchTables>
            <div class="row" v-if="menu.length > 0 && branchTables.length > 0 && selectedTable.status===1">
                <BranchMenu ref="BranchMenu" v-bind:menu="menu"
                 v-bind:selectedTableOrder="selectedTableOrder"
                  v-bind:selectedBranch="selectedBranch"
                  v-bind:selectedTable="selectedTable"
                  v-bind:branchTables="branchTables.filter(e=>e.status === 0 && e.tableType === 2 && e.deleted === false)"
                            @orderType="updateOrderType($event)"
                ></BranchMenu>
            </div>
        </div>
    </section>
</template>

<script>
    import PageTitle from "../components/layout_components/PageTitle";
    import AddUpdateMenu from "../components/restaurants/AddUpdateMenu";
    import ResturantBranches from "../components/pos/ResturantBranches";
    import BranchTables from '../components/pos/BranchTables';
    import BranchMenu from '../components/pos/BranchMenu';
    import Multiselect from 'vue-multiselect';
    export default {
        name: "ViewMenu",
        data: function () {
            return {
                restaurants: [],
                branches: [],
                menu: [],
                selectedRestaurant: "",
                selectedBranch: [],
                isHideSpinner: "hide",
                branchTables: "",
                itemOptions:[],
                selectedTable: {
                    id:0,
                    status:"",
                    name:""
                },
                branchWaiters:[],
                orderId: null,
                orderTypeOpened: "DineIn",
                selectedAdOnCategory: [], //we will show this in popup
                noAdOns: false,
                orderObject: {
                    id:0,
                    totalPrice:0,
                    discount: 0,
                    billedPrice:0,
                    deliveryFee: 0,
                    expectedDeliveryMinutes: null,
                  otherCancelReasons: null,
                    commision: 0,
                    totalDistance: 0,
                    totalPriceAfterTax:0,
                    totalPriceWithAddon:0,
                    pushTries:1,
                    fromDvmWeb:null,
                    orderWideInstructions:null,
                    table: null,
                    waiter: null,
                    cashTaken:0,
                    cashGiven:0,
                    paymentMethod: {
                        id:0
                    },
                    couponsByCouponId:null,
                    dvmAddress:null,
                    orderHistoriesById:[],
                    orderItemsById:[],
                    statusesByStatusId:{
                        id:12,
                        name:"",
                        cssClass:""
                    },
                  orderSource:{
                        id: 9,
                    },
                    ridersByRiderId:null,
                    customerAddressesByCustomerAddressId:null,
                    branchesByBranchId:{},
                    usersByUserId:{
                        id:"",
                        fullName:""
                    },
                    orderTypesByOrderTypeId:{
                        id:"",
                        type:""
                    },
                    complaints:[]
                },

                selectedTableOrder: {
                    id:0,
                    totalPrice:0,
                    discount: 0,
                    billedPrice:0,
                    deliveryFee: 0,
                    expectedDeliveryMinutes: null,
                  otherCancelReasons: null,
                    commision: 0,
                    totalDistance: 0,
                    totalPriceAfterTax:0,
                    totalPriceWithAddon:0,
                    pushTries:1,
                    fromDvmWeb:null,
                    orderWideInstructions:null,
                    table: null,
                    waiter: null,
                    cashTaken:null,
                    cashGiven:null,
                    paymentMethod:{
                        id:0,
                        name:""
                    },
                    couponsByCouponId:null,
                    dvmAddress:null,
                    orderHistoriesById:[],
                    orderItemsById:[],
                    statusesByStatusId:{
                        id:12,
                        name:"",
                        cssClass:""
                    },
                    ridersByRiderId:null,
                    customerAddressesByCustomerAddressId:null,
                    branchesByBranchId:{},
                    usersByUserId:{
                        id:""
                    },
                    orderTypesByOrderTypeId:{
                        id:"2",
                        type:"Dine In"
                    },
                    complaints:[],

                },

                    orderItem:{ //to append in orderItemsById
                        id:0,
                        quantity:1,
                        totalPrice:0,
                        instructions:null,
                        orderItemAddOnsById:[],
                        menuItemTypesByMenuItemTypeId:{
                            id:"",
                            price:"",
                            serving:"",
                            menuItemsByMenuItemId:{
                                id:0,
                                name: "",
                                description:"",
                                menuCategoriesByMenuCategoryId:{
                                    name:""
                                }
                            }
                        }

                    },

                    orderItemAddon:{
                        id:0,
                        quantity:1,
                        addOnItemsByAddOnItemId:{
                            id:0,
                            name:"",
                            price:"",
                            addOnCategoriesByAddOnCategoryId:{
                                id:0,
                                name:"",
                                allowedItems:0,
                                required:false
                            }
                        }
                    },

                    addonItem:{
                        id:0,
                    },

                    orderHistory: {
                        created:"",
                        statusesByStatusId:{
                            id:0,
                            name:"",
                            cssClass:""
                        }
                    },

                    status:{
                        id:0,
                        name:"",
                        cssClass:""
                    }
            }
        },
        computed: {
          isBranchUser() {
            return this.$store.state.user && this.$store.state.user.userRolesById  && this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
          }
        },
        components: {
            AddUpdateMenu, 
            PageTitle, 
            Multiselect, 
            ResturantBranches,
            BranchTables,
            BranchMenu,
            },
        updated: function () {
                $(".myTip").tooltip();
                $(".cartTip").tooltip({
                    placement: "bottom"
                });

            // $('.cart_panel, .category_panel').theiaStickySidebar({
            //     additionalMarginTop: 30,
                
            // });
            let $body   = $(document.body);
            let navHeight = $('.category_panel').outerHeight(true) + 10;
            $body.scrollspy({
                target: '.category_panel',
                offset: navHeight
            });
                $('.i-checks').iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green',
                });
        },
        methods: {
          updateOrderType(val) {
            this.orderTypeOpened = val === 1 ? 'Takeaway' : 'DineIn'
          },
            resetOrderItem: function(){
                    this.orderItem={ //to append in orderItemsById
                        id:0,
                        quantity:1,
                        totalPrice:0,
                        instructions:null,
                        orderItemAddOnsById:[],
                        menuItemTypesByMenuItemTypeId:{
                            id:"",
                            price:"",
                            serving:""
                        }
                    }
            },
            fetchBranchTables: function(){ //fetch all the tabells 
                this.selectedTable= {
                    id:0,
                    status:"",
                    name:""
                };
                let param4= new URLSearchParams();
                param4.append("branch_id", this.selectedBranch.id);
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_tables_of_branch", param4).then(resp=>{
                    this.branchTables= resp.data;
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_waiters_of_branch", param4)
                    .then(waiterresp=>{
                        this.branchWaiters="";
                        this.branchWaiters= waiterresp.data;
                    })
                })

            },
            showAdOns: function(AdOns) {
                this.noAdOns = false;
                (AdOns.menuItemTypeAdOns) && ( (AdOns.menuItemTypeAdOns.length === 0) && ( this.noAdOns = true ));
                (AdOns.menuItemAdOns) && ( (AdOns.menuItemAdOns.length === 0) && ( this.noAdOns = true ));
                this.selectedAdOnCategory = $.extend(true, {}, AdOns);
                    $("#adOnsPopUp").modal("show");
            },
            updateMenu: function () {
                this.$refs.addUpdateMenuPopUp.load(this.selectedBranch.id, this.selectedRestaurant.id);
            },
            updateOrderObject: async function(orderObject, selectedTableId){
                let resp= await this.$http.post(this.$store.state.mainAppURL + "pos/update_order_of_table/" + selectedTableId, orderObject);
            },
            getOrderObject: async function(selectedTableId){
                let resp= await this.$http.get(this.$store.state.mainAppURL + "pos/get_order_of_table/" + selectedTableId)
                return resp.data;
            },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.hide {
  display: none;
}
</style>
